import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {activerMajusculesGlobales} from './utils/majusculesGlobales';

// Installé avant le rendu, et jamais désinstallé : la règle vaut pour toute la durée de vie de
// l'application. Volontairement hors de React — un effet dans App serait démonté/remonté au
// gré des rendus, alors que l'écoute doit rester constante.
activerMajusculesGlobales();

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);
root.render(
    <React.StrictMode>
        <App/>
    </React.StrictMode>
);

reportWebVitals();
